import type { ApiError } from '@/shared/api';

const KNOWN: Record<string, string> = {
  resource_image_limit: 'Eine Ressource hat höchstens acht Fotos. Bitte zuerst eines entfernen.',
  resource_image_not_found: 'Das Foto gibt es nicht mehr. Die Liste ist aktualisiert.',
  resource_image_unreadable: 'Die Datei lässt sich nicht als Bild lesen.',
  resource_image_unavailable: 'Dieses Foto ist beschädigt – bitte entfernen und neu hochladen.',
  resource_not_found: 'Die Ressource gibt es in diesem Objekt nicht mehr. Bitte laden Sie neu.',
  object_not_found: 'Das Objekt wurde nicht gefunden.',
  file_too_large: 'Das Foto ist zu groß.',
  file_mime_not_allowed: 'Nur JPEG, PNG oder WebP.',
  file_magic_byte_mismatch: 'Die Datei ist kein gültiges Bild.',
  file_empty: 'Die Datei ist leer.',
  object_access_denied: 'Fotos pflegt nur, wer alle Apartments des Objekts verwalten darf.',
};

// Ein Code aus dem Server (`resource_image_limit`) — im Gegensatz zu einem Framework- oder
// Proxy-Text ohne Problem-Body. Unbekannte Codes bleiben als „Fehler <code>“ sichtbar.
const SERVER_CODE = /^[a-z][a-z0-9_]*$/;

function known(problem: ApiError, fallback: string): string {
  const text = KNOWN[problem.title];
  if (text) return text;
  if (problem.status === 403) return 'Dafür fehlt Ihnen die Berechtigung.';
  return SERVER_CODE.test(problem.title) ? `Fehler ${problem.title}` : fallback;
}

/**
 * Satz für ein gescheitertes Hochladen, Sortieren oder Entfernen — nie der rohe Servertext. Keine
 * Antwort ist kein Nein: das Foto kann gespeichert sein, ein zweiter Versuch legte es doppelt an.
 */
export function resourceImageFailureText(problem: ApiError): string {
  if (problem.status === 0) {
    return 'Keine Antwort vom Server – ob es geklappt hat, ist offen. Die Liste wird neu geladen; bitte dort prüfen.';
  }
  return known(problem, 'Das hat nicht geklappt. Bitte erneut versuchen.');
}

/** Warum die Fotos nicht geladen werden konnten — nie als „keine Fotos“ getarnt. */
export function resourceImageLoadFailureText(problem: ApiError): string {
  if (problem.status === 0) return 'Keine Verbindung zum Server.';
  return known(problem, 'Der Server konnte die Fotos gerade nicht liefern.');
}
